import makeStyles from "@mui/styles/makeStyles";
import { useTheme } from "@mui/styles";
import { Box, Typography } from "@mui/material";
import { useRef, useEffect } from "react";

const useStyles = makeStyles((theme) => ({
    bound: {
        borderStyle: `dashed`,
        padding: theme.spacing(2),
        borderRadius: 16
    },
    root: {
        position: "absolute",
        zIndex: 10
    }
}));

interface Props
{
    zoom: number
    index: number
    sharedData?: { height: number }[]
    setTitleHeight: (height: number) => void;
    x: number;
    y: number;
    width: number;
    height: number;
    title: string;
    color: string;
}

export default function GroupBox({ x, y, index, width, height, setTitleHeight, title, color, zoom, sharedData }: Props)
{
    const classes = useStyles();
    const theme = useTheme();
    const fontSize = Math.max((1 / zoom) * 12, 12);

    const titleHeight = sharedData ? sharedData[index]?.height ?? 0 : 0;
    const titleRef = useRef<HTMLSpanElement>(null)

    const titleOffset = sharedData ? sharedData.reduce((sum, current, dataIndex) =>
    {
        if (dataIndex < index)
            sum += current?.height ?? 0;
        return sum;
    }, 0) : 0;

    useEffect(() =>
    {
        if (titleRef.current)
        {
            setTitleHeight(titleRef.current.clientHeight);
        }
    }, [zoom, setTitleHeight]);

    const borderWidth = 2 / zoom;
    return <Box className={classes.root} style={{ left: x, top: y }}>
        <Typography ref={titleRef} style={
            {
                fontSize: `${fontSize}px`,
                marginBottom: `${zoom * 12}px`,
                position: "absolute",
                left: -(borderWidth),
                top: -(borderWidth + parseInt(theme.spacing(2)) + titleHeight + titleOffset)
            }}>{title}</Typography>
        <Box className={classes.bound} style={
            {
                borderColor: color,
                width, height,
                borderWidth,
                transform: `translate(-${parseInt(theme.spacing(2)) + borderWidth}px, -${parseInt(theme.spacing(2)) + borderWidth}px)`,
            }} />
    </Box>
}